import script from "./AdminMailings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMailings.vue?vue&type=script&setup=true&lang=js"

import "./AdminMailings.vue?vue&type=style&index=0&id=93b86284&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93b86284"]])

export default __exports__